import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

import Country from './Country';

export default class CaseStudy extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get id() {
    return this.system.id;
  }

  get title() {
    return get(this, '_tytul.value', '');
  }

  get projectname() {
    return get(this, '_nazwa_projektu.value', '');
  }

  get clientname() {
    return get(this, '_nazwa_klienta.value', '');
  }

  get location() {
    return get(this, '_miejsce.value', '');
  }

  get country() {
    return get(this, '_kraj.value[0]', new Country());
  }

  get projectLogo() {
    return get(this, '_logo_projektu.value[0].url', '');
  }

  get photo() {
    return get(this, '_zdjecie.value[0].url', '');
  }

  get company() {
    return get(this, '_wykonawca.value', []);
  }

  get numberOfEmployees() {
    return get(this, '_ilosc_pracownikow.value');
  }

  get establishYear() {
    return get(this, '_rok_zalozenia.value', '');
  }

  get sector() {
    return get(this, '_branza.value', '');
  }

  get services() {
    return get(this, '_uslugi.value', '');
  }

  get slug() {
    return get(this, '_slug.value', '');
  }

  get text() {
    return get(this, '_tekst.value', '');
  }

  get comment() {
    return get(this, '_komentarz.value', []);
  }

  get url() {
    return get(this, '_url.value', '');
  }

  get publishDate() {
    return get(this, '_data_publikacji.value', '');
  }

  get publishYear() {
    const d = this.publishDate;
    if (d) {
      return +d.split('-')[0];
    }
    return null;
  }

  get seo() {
    const seoModel = get(this, '_seo[0].model', {});

    if (!seoModel.title) {
      seoModel.title = this.title;
    }

    return seoModel;
  }
}



// WEBPACK FOOTER //
// ./src/models/CaseStudy.model.js